import { useMemo } from "react";

export interface EstadisticasNumericas {
  total: number;
  promedio: number;
  minimo: number;
  maximo: number;
}

export const useEstadisticasNumericas = <T>(
  items: T[],
  mapearValor: (item: T) => number
): EstadisticasNumericas | null => {
  return useMemo(() => {
    const valores = items.map(mapearValor);

    if (valores.length <= 1) {
      return null;
    }

    const sumaValores = valores.reduce(
      (acumulado, valor) => acumulado + valor,
      0
    );

    return {
      total: sumaValores,
      promedio: sumaValores / valores.length,
      minimo: Math.min(...valores),
      maximo: Math.max(...valores),
    };
  }, [items, mapearValor]);
};
